import { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';
import { milestoneHaptic } from '../lib/native';

export const fireConfetti = () => {
  milestoneHaptic();
  const colors = ['#8A9A86', '#D97A62', '#E8A365', '#9CBCB1', '#C2A878'];
  confetti({
    particleCount: 80,
    spread: 70,
    startVelocity: 35,
    origin: { y: 0.7 },
    colors,
    scalar: 0.9,
  });
  setTimeout(() => {
    confetti({
      particleCount: 60,
      angle: 60,
      spread: 60,
      origin: { x: 0, y: 0.7 },
      colors,
    });
    confetti({
      particleCount: 60,
      angle: 120,
      spread: 60,
      origin: { x: 1, y: 0.7 },
      colors,
    });
  }, 200);
};

// Optional component if you want to mount once on milestones
export const ConfettiTrigger = ({ when }) => {
  const fired = useRef(false);
  useEffect(() => {
    if (when && !fired.current) {
      fired.current = true;
      fireConfetti();
      const t = setTimeout(() => { fired.current = false; }, 1500);
      return () => clearTimeout(t);
    }
  }, [when]);
  return null;
};
